// @flow
import * as React from 'react';
import { LoadingSpinner } from '@ta/styleguide.loading';
import styles from './TripDetailSkeletonLoader.less';

// TODO: stopgap loading state for trip modal. See TRIP-2861 for a general loading state pattern for both the detail page and modal
const TripDetailSkeletonLoader = () => (
  <div className={styles.wrapper}>
    <LoadingSpinner />
  </div>
);

export default TripDetailSkeletonLoader;
